// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".bundle.min.js?h=" + {"38":"942759dceb504410","73":"9cf6dd0154aa062b","487":"601d7541f043d2b6","821":"8dfec8ab95f12b68","882":"893371b19c2448e9"}[chunkId] + "";
};